module.exports = __webpack_public_path__ + "img/协会.a675f955.jpg";